import Vue from "vue"
import VueRouter from "vue-router"
import HomePage from "./pages/business-home-page"
// import PlansPage from "./pages/business-plans-page"
import TeamsPage from "./pages/business-teams-page"
// import BusinessDemoPage from "./pages/business-demo-page"
import BusinessSelectTeamSizePage from "./pages/select-team-size-page"
import BusinessBlogLearningHabitsPage from "./pages/business-blog-learning-habits"
import getUserInfo from "@/modules/user-info-store"
import api from "@/api"
import { go } from "@/utils/location"
import globals from "@/utils/globals"
import { createVueRouterPageViewTrackingHandler } from "services/tracking/piwik"
import { getLocaleBase } from "@/utils/locale"

Vue.use(VueRouter)

const routes = [
  {
    path: "/teams",
    component: TeamsPage,
    meta: {
      showHeaderLinks: true
    }
  },
  {
    path: "/select-team-size",
    component: BusinessSelectTeamSizePage,
    beforeEnter: (to, from, next) => {
      Promise.all([getUserInfo(), api.organisations.me()])
        .then(([config]) => {
          if (config.segment === "anonymous") return go("/404")

          return next()
        })
        .catch(() => {
          go(globals.business.afterLoginPath)
        })
    }
  },
  {
    path: "/blog/7-highly-effective-learning-habits-that-will-boost-your-teams-productivity",
    component: BusinessBlogLearningHabitsPage,
    meta: {
      showHeaderLinks: true
    }
  },
  {
    path: "/",
    component: HomePage,
    meta: {
      showHeaderLinks: true
    }
  },
  {
    path: "*",
    redirect: "/"
  }
]

const initRouter = () => {
  const router = new VueRouter({
    mode: "history",
    base: `/${getLocaleBase()}`,
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 }
    }
  })
  router.afterEach(createVueRouterPageViewTrackingHandler(router))
  return router
}

export default initRouter
